var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[
    'activity-text-btn',
    _vm.sizingClass,
    { 'no-shadow': _vm.flat },
    { 'activity-text-btn--focused': _vm.focused },
    { 'activity-text-btn--small-squared': _vm.smallSquared },
    { 'activity-text-btn--squared': _vm.squared },
    { 'activity-text-btn--clue': _vm.isClue },
    { 'activity-text-btn--hint': _vm.hint },
    { 'activity-text-btn--disabled': _vm.disabled || _vm.hint },
  ],style:({
    background: _vm.secondaryBgColor || _vm.bgColor,
    color: _vm.color,
  }),on:{"mousedown":function($event){_vm.focused = true},"mouseup":function($event){_vm.focused = false},"touchstart":function($event){_vm.focused = true},"touchend":function($event){_vm.focused = false},"focus":_vm.onFocus,"blur":_vm.onBlur}},[(_vm.focused && _vm.squared)?_c('i',{staticClass:"fas fa-arrows-alt activity-text-btn__icon"}):_vm._e(),_c('span',{class:{ 'activity-text-btn__content--focused': _vm.focused }},[(_vm.hasAudio)?_c('IconVolumeHigh'):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }